module.exports = __webpack_public_path__ + "static/media/realEstateMainTitle.a59ae938.jpg";